interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
  children?: React.ReactNode;
}

export default function EmptyState({
  icon = "ri-movie-2-line",
  title,
  description,
  actionLabel,
  onAction,
  children,
}: EmptyStateProps) {
  return (
    <div className="w-full py-16 md:py-24 flex flex-col items-center justify-center text-center px-4">
      <div className="w-16 h-16 rounded-full bg-background-100 border border-background-200 flex items-center justify-center text-foreground-400 text-2xl mb-5">
        <i className={icon} />
      </div>
      <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900">{title}</h3>
      {description && (
        <p className="mt-2 text-sm text-foreground-500 max-w-md leading-relaxed">{description}</p>
      )}
      {actionLabel && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="mt-6 h-10 px-5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          {actionLabel}
        </button>
      )}
      {children}
    </div>
  );
}

export function CardGridSkeleton({ count = 10 }: { count?: number }) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 xl:grid-cols-5 gap-3 md:gap-5">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i}>
          <div className="w-full aspect-[2/3] rounded-lg cc-skeleton" />
          <div className="h-3.5 w-3/4 rounded cc-skeleton mt-3" />
          <div className="h-3 w-1/2 rounded cc-skeleton mt-2" />
        </div>
      ))}
    </div>
  );
}

export function Spinner({ label = "加载中…" }: { label?: string }) {
  return (
    <div className="w-full py-20 flex flex-col items-center justify-center gap-3">
      <span className="w-8 h-8 rounded-full border-2 border-background-200 border-t-accent-500 animate-spin" />
      <p className="text-sm text-foreground-500">{label}</p>
    </div>
  );
}